// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from "firebase/firestore"; // Import getFirestore from the correct path
import { getStorage } from "firebase/storage"; 
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCQMuHc2P9Lg6VzWW-fiGcr4S-B42fPz_M",
  authDomain: "portfolio-c672a.firebaseapp.com",
  projectId: "portfolio-c672a",
  storageBucket: "portfolio-c672a.appspot.com",
  messagingSenderId: "756564579189",
  appId: "1:756564579189:web:98ac3d22a3ba12253a793c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore



export { db };